/**
 * Normalize the various id shapes the API returns (plain string, EJSON
 * `{ $oid }`, embedded `{ _id }` / `{ id }` documents, card refs) down to a
 * plain string id, or undefined when there is no usable id.
 */
export function normalizeId(maybe) {
	if (!maybe) return undefined;
	if (typeof maybe === 'string') return maybe;
	if (typeof maybe === 'object') {
		if (typeof maybe.$oid === 'string') return maybe.$oid;
		if (typeof maybe.cardDefinitionId === 'string') return maybe.cardDefinitionId;
		if (typeof maybe.card_id === 'string') return maybe.card_id;
		if (maybe._id) return normalizeId(maybe._id);
		if (maybe.id) return normalizeId(maybe.id);
	}
	try {
		return maybe.toString();
	} catch {
		return undefined;
	}
}

export default normalizeId;
